import { CERTIFICATES, EDUCATION, PERSONAL_INFO, PROFESSIONAL_EXPERIENCE, PROFESSIONAL_SUMMARY, SELECT_PROFILE, SKILLS } from "./ResumeTypes";

const initialState = {
  userId: null,
  profileName: "",
   id: null,
  contactNo: "",
  objective: "",
  firstName: "",
  lastName: "",
  email: "",
  profileData: {
    professionalSummary: "",
    certificates: [],
    technicalSkills: {
      technology: [],
      programming: [],
      tools: [],
    },
    professionalExperience: [],
    education: [],
    
  },
  selectedProfile: null,
};

const resumeReducer = (state = initialState, action) => {
  switch (action.type) {
    case PERSONAL_INFO:
      // Destructure to separate profileData from personal info fields
      const { profileData, ...personalInfoFields } = action.payload;
      return {
        ...state,
        ...personalInfoFields,
        // Always preserve existing profileData
        profileData: state.profileData,
      };

    case EDUCATION:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          education: action.payload,
        },
      };

    case PROFESSIONAL_EXPERIENCE:
      console.log('Payload:', action.payload);
      return {
        ...state,
        profileData: {
          ...state.profileData,
          professionalExperience: action.payload,
        },
      };

    case SKILLS:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          technicalSkills: action.payload,
        },
      };

    case PROFESSIONAL_SUMMARY:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          professionalSummary: action.payload,
        },
      };

    case CERTIFICATES:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          certificates: action.payload,
        },
      };

      case SELECT_PROFILE:
      return {
        ...state,
        selectedProfile: action.payload, 
      };

    default:
      return state;
  }
};

export default resumeReducer;
